export const polyfill = (): void => {
  // Safari polyfill
  // https://sentry.demv-systems.de/organizations/demv-systems/issues/53804
  if (Object.hasOwn === undefined) {
    Object.defineProperty(Object, 'hasOwn', {
      // @ts-expect-error: we dont care for the polyfill here
      value(object, property) {
        if (object == null) {
          throw new TypeError('Cannot convert undefined or null to object');
        }

        return Object.prototype.hasOwnProperty.call(Object(object), property);
      },
      configurable: true,
      enumerable: false,
      writable: true,
    });
  }
};
